module.exports = __webpack_public_path__ + "img/c1fd12f.jpg";